import React from 'react';
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifFormField,
  MotifErrorMessage,
} from '@ey-xd/motif-react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';
import * as formValidators from '../../scripts/formValidators';

const AddGroupModal = ({
  showAddGroupModal,
  toggleShowAddGroupModal,
  addGroupModalHeader,
  handleSubmit,
  handleSaveAddGroup,
  validationMessage,
  clearValidationMessage,
}) => {
  const submitForm = (formValues, saveAndAddAnother) => {
    handleSaveAddGroup(formValues, saveAndAddAnother);
  };

  return (
    <MotifModal
      variant="alt"
      show={showAddGroupModal}
      onClose={() => toggleShowAddGroupModal()}
      data-testid="divAddGroupModal"
    >
      <MotifModalHeader data-testid="lblAddGroupsModelHeader">
        <span className="ml-2">{addGroupModalHeader}</span>
      </MotifModalHeader>
      <form
        onSubmit={handleSubmit((formValues) => submitForm(formValues, false))}
        className="addGroupForm"
      >
        <MotifModalBody>
          <MotifFormField>
            <div>
              <div>
                <Field
                  name="groupName"
                  component={formHelpers.renderField}
                  type="text"
                  maxLength={255}
                  label="Enter a New Group Name"
                  dataTestId="txtEnterNewGroupName"
                  isRequiredField={true}
                  validate={[
                    formValidators.required,
                    formValidators.alphaNumeric,
                    formValidators.maxLength255,
                  ]}
                  onChange={clearValidationMessage}
                />
                {(validationMessage && (
                  <MotifErrorMessage data-testid="pErrorMsg" variant="error">
                    {validationMessage}
                  </MotifErrorMessage>
                )) ||
                  null}
              </div>
            </div>
          </MotifFormField>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            variant="secondary"
            type="button"
            onClick={() => toggleShowAddGroupModal()}
            className="right mt-3"
            data-testid="btnCancel"
          >
            Cancel
          </MotifButton>
          <MotifButton
            variant="primary-alt"
            type="button"
            className="right mt-3"
            data-testid="btnSaveAddAnotherGroup"
            onClick={handleSubmit((formValues) => submitForm(formValues, true))}
          >
            Save and Add Another Group
          </MotifButton>
          <MotifButton
            type="submit"
            className="right mt-3"
            data-testid="btnSave"
            onClick={handleSubmit((formValues) =>
              submitForm(formValues, false)
            )}
          >
            Save
          </MotifButton>
        </MotifModalFooter>
      </form>
    </MotifModal>
  );
};

AddGroupModal.propTypes = {
  showAddGroupModal: PropTypes.bool,
  toggleShowAddGroupModal: PropTypes.func,
  addGroupModalHeader: PropTypes.string,
  handleSaveAddGroup: PropTypes.func,
  handleSubmit: PropTypes.func, // This prop is provided by reduxForm,
  validationMessage: PropTypes.string,
  clearValidationMessage: PropTypes.func,
};

export default reduxForm({ form: 'addGroupForm', enableReinitialize: true })(
  AddGroupModal
);
